/** Auto-generated */
export const landingUnsupportedEn = {
  paymentSuccess: {
    seo: {
      title: 'Payment Successful - Veeso AI',
    },
    hero: {
      title: 'Payment Successful!',
      description:
        'Thank you for your purchase. Your subscription has been successfully activated.',
    },
    checkout_id_label: 'ID:',
    cta: {
      continue: 'Continue where you left off',
      dashboard: 'Go to Dashboard',
      home: 'Back to Home',
    },
    footer: {
      need_help: 'Need help?',
      contact: 'Contact Support',
    },
  },
  auth: {
    callback: {
      seo: {
        title: 'Authenticating... - Veeso AI',
      },
      loading: 'Authenticating, please wait...',
    },
  },
  error: {
    seo: {
      title_404: '404 - Page Not Found | Veeso AI',
      title_generic: 'Error | Veeso AI',
    },
    title_404_line1: 'Lost in',
    title_404_line2: 'the void',
    title_generic_line1: 'Something',
    title_generic_line2: 'went wrong',
    desc_404:
      "The page you're looking for doesn't exist or has been moved. Let's get you back on track.",
    desc_generic_fallback: 'An unexpected error occurred.',
    cta: {
      home: 'Back to Home',
    },
    dev: {
      toggle: 'Error Details (Dev Mode)',
    },
  },
  legal: {
    privacy: {
      page: {
        last_updated: 'Last Updated Date: December 27, 2025',
      },
    },
    cookie: {
      page: {
        last_updated: 'Last Updated Date: March 06, 2026',
      },
    },
  },
  aiToolsIndex: {
    empty_state: 'No AI tools available yet. Check back soon!',
    card: {
      cta: 'Try Generator',
    },
    seo_content: {
      hero: {
        title: 'Why Choose Veeso AI?',
        subtitle: 'Stop Generating Images. Start Generating Designs.',
      },
      compare: {
        traditional: {
          title: 'Traditional AI Image Tools',
          items: [
            'Static images',
            'No content hierarchy',
            'Hard to modify text',
            'Not production-ready',
            'One-shot generation',
            'Limited export formats',
            'Requires design skills to edit',
            'Fixed dimensions only',
            'No version control',
            "Can't adapt to content length",
            'No multi-page support',
            'Time-consuming editing process',
            'No brand consistency tools',
          ],
        },
        veeso: {
          title: 'Veeso AI',
          items: [
            'Structured layouts',
            'Clear layout structure',
            'Fully editable layers',
            'Built for real publishing',
            'Edit, refine, export freely',
            'Multiple export formats',
            'Content-first workflow',
            'No design skills required',
            'Flexible dimensions',
            'Iterative refinement',
            'Adapts to content automatically',
            'Multi-page layouts supported',
            'Fast editing workflow',
            'Brand consistency features',
          ],
        },
      },
    },
  },
  blog: {
    index: {
      seo: {
        title: 'Learn & Blog - Veeso AI',
      },
      hero: {
        title: 'Learn & Blog',
      },
      card: {
        read_more: 'Read more',
      },
      image_alt_fallback: 'Blog post image',
      faq: {
        items: [
          {
            question: 'What topics are covered in the Learn & Blog section?',
            answer:
              'Our Learn & Blog section covers a wide range of topics including AI design best practices, content creation strategies, marketing tips, design tutorials, case studies, and insights on how to use Veeso AI effectively. We regularly publish articles to help you create better designs and improve your workflow.',
          },
          {
            question: 'How often are new articles published?',
            answer:
              'We publish new articles regularly to keep you updated with the latest trends, tips, and best practices in AI-powered design. Check back frequently or subscribe to stay informed about new content.',
          },
          {
            question: 'Can I suggest topics for future blog posts?',
            answer:
              "Yes! We welcome suggestions for topics you'd like to see covered. Feel free to reach out to us through our contact page or social media channels with your ideas.",
          },
          {
            question: 'Are the tutorials suitable for beginners?',
            answer:
              'Absolutely! Our tutorials are designed to be accessible to users of all skill levels, from complete beginners to experienced designers. Each tutorial includes step-by-step instructions and clear explanations.',
          },
          {
            question: 'Can I share articles from the Learn & Blog section?',
            answer:
              "Yes, you're welcome to share our articles! We encourage sharing on social media and with your team. Each article includes social sharing options for your convenience.",
          },
          {
            question: 'Do the articles include practical examples?',
            answer:
              'Yes! Our articles often include real-world examples, case studies, and practical tips that you can apply immediately to your own design projects. We focus on actionable insights rather than just theory.',
          },
          {
            question: 'How can I stay updated with new blog posts?',
            answer:
              'You can stay updated by visiting the Learn & Blog section regularly, or follow us on social media where we announce new articles. We also recommend bookmarking the page for easy access.',
          },
          {
            question: 'Are there any video tutorials available?',
            answer:
              'While our blog focuses primarily on written content and tutorials, we occasionally include video content and links to video resources. Check individual articles for multimedia content.',
          },
          {
            question: 'Can I use the design examples from articles in my own projects?',
            answer:
              'Yes! The examples and templates shared in our articles are meant to inspire and guide your own projects. Feel free to adapt the concepts and ideas to fit your specific needs.',
          },
          {
            question: 'How do I find articles on specific topics?',
            answer:
              'You can browse articles by scrolling through the Learn & Blog page. Articles are organized chronologically, and you can use the search function (if available) or browse by category tags to find content on specific topics.',
          },
        ],
      },
    },
  },
  spotlight: {
    index: {
      seo: {
        title_fallback: 'Spotlight - Veeso AI',
      },
      hero: {
        title_fallback: 'Spotlight',
      },
      card: {
        read_more: 'Read more',
      },
      empty_state: 'No spotlight posts available yet. Check back soon!',
    },
  },
  common: {
    error: 'Error',
  },
  language_switcher: {
    aria_label: 'Language',
  },
  pricing: {
    breadcrumb: {
      home: 'Home',
      pricing: 'Pricing',
    },
  },
  help: {
    getting_started: {
      ui_terms: 'Sign Up, Create, Generate, Export 等',
    },
  },
};
export const landingUnsupportedMiscEn = {
  common: {
    error: 'Error',
  },
  pricing: {
    breadcrumb: {
      home: 'Home',
      pricing: 'Pricing',
    },
  },
  languageSwitcher: {
    aria_label: 'Language',
  },
};
